
















































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Image, Page } from '../types'

interface VForm extends Vue {
  $el: HTMLFormElement
  validate(): boolean
  reset(): void
}

@Component
export default class Contact extends Vue {
  $refs!: {
    form: VForm
  }

  page: Page | null = null
  nameRules = [(v: string) => !!v || 'Uw naam is verplicht']
  emailRules = [
    (v: string) => !!v || 'Uw email is verplicht',
    (v: string) => /.+@.+/.test(v) || 'Ongeldig email adress',
  ]
  phoneRules = []
  messageRules = []

  successMessage: string | null = null
  errorMessage: string | null = null

  get layoutBinding(): { [key: string]: any } {
    const binding: { [key: string]: any } = {}

    if (this.$vuetify.breakpoint.smAndDown) {
      binding['pt-4'] = true
      binding['px-2'] = true
    } else {
      binding['py-5'] = true
    }

    return binding
  }

  created() {
    fetch('//www.klussenmetkees.nl/wp-json/wp/v2/pages?_embed&slug=contact')
      .then((response: any) => response.json())
      .then((pages: any[]) => {
        const page = pages[0]
        const embedded = page._embedded

        const featuredMediaId = page.featured_media
        const featuredMedia = embedded['wp:featuredmedia'].filter((fm: any) => fm.id === featuredMediaId)[0]
        const img = new Image(
          featuredMedia.title.rendered,
          featuredMedia.alt_text,
          featuredMedia.media_details.sizes.medium.source_url,
          featuredMedia.media_details.sizes.full.source_url,
        )

        this.page = new Page(page.title.rendered, page.content.rendered, img)
      })
      .catch((err: Error) => {
        console.error('could not fetch page', err)
      })
  }

  async submit(): Promise<void> {
    const form = this.$refs.form
    const formEl = form.$el

    if (form.validate()) {
      try {
        const resp = await fetch(formEl.action, { method: formEl.method })
        if (resp.status >= 400) {
          throw new Error('error status code')
        }
        this.errorMessage = null
        this.successMessage = 'Dank u wel, het formulier is verzonden!'
        form.reset()
      } catch (err) {
        this.successMessage = null
        this.errorMessage = 'Helaas, er ging iets mis'
      }
    }
  }
}
